//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { displayRuleHelper } from "display-rules";
import FormModelGenerator from "@/src/form-helpers/form-model-generator";
import { visibleFields } from "@/src/form-helpers/visible-fields";

export default {
  props: {
    submission: {
      required: true,
    },
    fields: {
      required: true,
    },
    remakeFromServerTimestamp: {
      required: false,
    },
  },
  data() {
    let localData = new FormModelGenerator(this.fields, this.submission)
      .generateData;
    if (localData != this.submission) {
      this.$emit("updateData", localData);
    }
    return {
      localData,
      previousRadioValues: {},
    };
  },
  computed: {
    visibleFields() {
      if (this.localData) {
        return visibleFields(this.fields, this.localData);
      } else {
        return this.fields.filter((field) =>
          displayRuleHelper(field.display_rules, this.submission)
        );
      }
    },
  },
  watch: {
    remakeFromServerTimestamp: {
      handler() {
        this.localData = new FormModelGenerator(
          this.fields,
          this.submission
        ).generateData;
      },
    },
    localData: {
      handler(newValue) {
        this.visibleFields
          .filter((field) => field.isRadioWithOptions)
          .forEach((field) => {
            newValue[`${field.name}_checkbox`] = newValue[field.name]
              ? newValue[field.name].checkbox
              : null;
            newValue[`${field.name}_radio`] = newValue[field.name]
              ? newValue[field.name].radioButton
              : null;
          });

        // Handle also_sets for radio fields (only when radio value changes)
        this.visibleFields
          .filter(
            (field) => (field.isRadio || field.isAddonRadio) && field.options
          )
          .forEach((field) => {
            const selectedValue = newValue[field.name];
            const previousValue = this.previousRadioValues[field.name];

            if (selectedValue !== previousValue) {
              this.previousRadioValues[field.name] = selectedValue;
              const selectedOption = field.options.find(
                (option) => option.value === selectedValue
              );
              if (selectedOption && selectedOption.also_sets) {
                Object.keys(selectedOption.also_sets).forEach((key) => {
                  newValue[key] = selectedOption.also_sets[key];
                });
              }
            }
          });

        this.$emit("updateData", newValue);
      },
      deep: true,
    },
  },
  methods: {
    onSubmit(evt) {
      this.$emit("nextPage");
    },
    submit() {
      this.$refs.form.submit();
    },
  },
};
